class InstructionsDatabase extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.groupedData = null;
    this.featuredData = [];
    this.featuredTitle = null;
    this.featuredButtonTitle = null;
    this.background = null;
    this.cache = new Map();
    this.isRendered = false;
  }

  static get observedAttributes() {
    return [
      "data",
      "featured",
      "featured-title",
      "featured-button-title",
      "background",
    ];
  }

  async fetchData(url) {
    if (this.cache.has(url)) {
      return this.cache.get(url).cloneNode(true);
    }

    const response = await fetch(url);
    const text = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "text/html");
    const result = doc.querySelector(".test");

    if (result) {
      this.cache.set(url, result.cloneNode(true));
    }

    return result;
  }

  loadStylesheets() {
    const cssUrls = [
      "/cdn/shop/t/22/assets/webcomponent.css",
      "/cdn/shop/t/22/assets/theme.css",
      "/cdn/shop/t/22/assets/tailwind.min.css",
    ];

    return Promise.all(
      cssUrls.map((href) => {
        return new Promise((resolve, reject) => {
          const link = document.createElement("link");
          link.rel = "stylesheet";
          link.href = `${href}?v=${Date.now()}`;
          link.onload = resolve;
          link.onerror = reject;
          this.shadowRoot.appendChild(link);
        });
      })
    );
  }

  async attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;
    if (name === "data") {
      this.data = JSON.parse(newValue);
      this.groupedData = this.groupData(this.data);
    } else if (name === "featured") {
      this.featuredData = JSON.parse(newValue);
      this.groupedFeaturedData = this.groupFeatured(this.featuredData);
    } else if (name == "featured-title") {
      this.featuredTitle = newValue;
    } else if (name == "featured-button-title") {
      this.featuredButtonTitle = newValue;
    } else if (name == "background") {
      this.background = newValue;
    }
    if (this.groupedData && this.groupedFeaturedData && !this.isRendered) {
      this.groupedData = [this.groupedFeaturedData[0], ...this.groupedData];
      const firstGroup = this.groupedData?.[0]?.children?.[0];
      await this.loadStylesheets();
      this.render();
      // if (firstGroup) {
      //   const url = `${window.Shopify.routes.root}collections/${firstGroup.handle}?view=data`;
      //   const results = await this.fetchData(url);
      //   if (results) {
      //     // Insert the results into the right container AFTER render
      //     const featuredContent = this.shadowRoot.querySelector(
      //       `.group[data-tab-index="0"]`
      //     );
      //     if (featuredContent) {
      //       featuredContent.innerHTML = results.innerHTML;
      //     }
      //   }
      // }
    }
  }

  groupData(data) {
    return Object.values(
      data.reduce((acc, item) => {
        if (!item.hasInstructions) return acc;

        const group = item.name[0].toUpperCase();
        acc[group] ??= {
          group,
          children: [],
          first: item.first,
          image: item.image,
          hasInstructions: item.hasInstructions,
        };
        acc[group].children.push(item);

        return acc;
      }, {})
    );
  }

  groupFeatured(data) {
    return Object.values(
      data.reduce((acc, item) => {
        if (!item.hasInstructions) return acc;

        const group = this.featuredTitle;
        acc[group] ??= {
          group,
          children: [],
          first: item.first,
          image: item.image,
          hasInstructions: item.hasInstructions,
        };
        acc[group].children.push(item);

        return acc;
      }, {})
    );
  }

  render() {
    if (
      !this.groupedData ||
      !Array.isArray(this.groupedData) ||
      this.groupedData.length === 0
    ) {
      return;
    }

    const className = `card-container ${
      this.background === "#ffffff" ? "white" : ""
    }`;

    console.log(this.groupedData, this.featuredData, this.featuredTitle, this.featuredButtonTitle, this.background, this.groupedFeaturedData)

    const groupedData = Array.isArray(this.groupedData) ? this.groupedData : [];

    const tabsHTML = `
      <div class="custom-container">

        <div class="letter-list ${className}">
          ${groupedData
            .map(
              (group, index) => `
                <a data-tab-index="${index}" data-handle="${
                group.group
              }" aria-selected="${index === 0}" class="tab letters ${
                index === 0 ? "active featured" : ""
              }">
                    ${group.group}
                  </a>
              `
            )
            .join("")}
        </div>

        <div>
          <h3 class="heading h4">Select a Brand</h3>
        </div>
        
        <div class="brands ${className}">
          ${groupedData
            .map(
              (group, index) => `
                <div data-tab-index="${index}" class="brand-group ${
                index !== 0 ? "hidden" : ""
              }">
                    ${group.children
                      .map(
                        (brand) => `
                          <div class="brand-item">
                            <a href="#" data-handle="${
                              brand.handle
                            }" class="brand-link">
                              <div class="item" style="${
                                brand.image
                                  ? ""
                                  : "justify-content:center;text-align:center;"
                              }">
                                ${
                                  brand.image
                                    ? `<img src="${brand.image}">`
                                    : `${brand.name}`
                                }
                              </div>
                            </a>
                          </div>
                        `
                      )
                      .join("")}
                  </div>
              `
            )
            .join("")}
        </div>

       <div class="content ${className}">
          ${groupedData
            .map(
              (group, index) => `
                <div data-tab-index="${index}" class="group ${
                index !== 0 ? "hidden" : ""
              }">
                  ${
                    index === 0
                      ? this.featuredData?.outerHTML ??
                        `<div class="loading">Choose a Brand...</div>`
                      : ""
                  }
                </div>
              `
            )
            .join("")}
        </div>

      </div>
    `;

    const container = document.createElement("div");
    container.innerHTML = tabsHTML;
    this.shadowRoot.appendChild(container.firstElementChild);

    this.shadowRoot.querySelectorAll(".tab").forEach((tab) => {
      tab.addEventListener("click", this.handleTabClick.bind(this));
    });

    this.shadowRoot
      .querySelectorAll(".brand-group .brand-item a")
      .forEach((brandLink) => {
        brandLink.addEventListener("click", this.handleBrandClick);
      });
  }

  handleBrandClick = async (event) => {
    event.preventDefault();

    const handle = event.currentTarget.dataset.handle;
    const tabIndex =
      event.currentTarget.closest(".brand-group")?.dataset.tabIndex;

    this.shadowRoot
      .querySelectorAll(
        `.brand-group[data-tab-index="${tabIndex}"] .brand-item`
      )
      .forEach((item) => item.classList.remove("active"));

    event.currentTarget.parentElement.classList.add("active");

    if (!handle || tabIndex === null) return;

    const container = this.shadowRoot.querySelector(
      `.group[data-tab-index="${tabIndex}"]`
    );
    if (!container) return;

    container.innerHTML = "";

    const url = `${window.Shopify.routes.root}collections/${handle}?view=data`;
    const results = await this.fetchData(url);

    container.innerHTML = results?.innerHTML || "";
  };

  handleTabClick = async (event) => {
    const index = event.currentTarget.dataset.tabIndex;

    this.shadowRoot.querySelectorAll(".tab").forEach((tab) => {
      tab.setAttribute("aria-selected", tab.dataset.tabIndex === index);
      tab.classList.toggle("active", tab.dataset.tabIndex === index);
    });

    this.shadowRoot.querySelectorAll(".group").forEach((group) => {
      group.classList.toggle("hidden", group.dataset.tabIndex !== index);
    });

    this.shadowRoot.querySelectorAll(".brand-group").forEach((group) => {
      group.classList.toggle("hidden", group.dataset.tabIndex !== index);
    });
  };
}

customElements.define("instructions-database", InstructionsDatabase);